import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import { withForm } from "../../../hooks/use-form";
import { useAppointmentStore } from "../../../store/appointment/appointment-store";
import { CONTACT_FORM_INITIAL_VALUES } from "../../../store/appointment/appointment-store.constants";
import { useGenderOptions } from "../../desktop/screens/appointment-content/appointment-form/appointment-form.constant";
import styles from "./appointment-form-mobile.module.scss";

export const AppointmentFormMobile = withForm({
  defaultValues: CONTACT_FORM_INITIAL_VALUES,
  render: ({ form }) => {
    const { t } = useTranslation();
    const GENDER_OPTIONS = useGenderOptions();
    // customFieldKeys keys are sent in the payload for appointment booking
    const { userAppointmentData, setCustomFieldKeys, initialContactFormData }
      = useAppointmentStore();
    const [customFieldsTitle, setCustomFieldsTitle] = useState<string[]>([]);
    const customFieldsMemoized = useMemo(
      () =>
        JSON.parse(userAppointmentData?.extra?.event_type?.payload ?? "{}")
        ?? [],
      [userAppointmentData?.extra?.event_type?.payload],
    );

    useEffect(() => {
      const customFieldsTitleArr = customFieldsMemoized?.custom_fields?.map(
        (field: any) => field.title,
      );
      const customFieldsKeysArr = customFieldsMemoized?.custom_fields?.map(
        (field: any) => field.key,
      );
      const customFields = initialContactFormData?.customFields?.length
        ? initialContactFormData?.customFields
        : Array.from({ length: customFieldsTitleArr?.length })?.fill("");
      setCustomFieldsTitle(customFieldsTitleArr);
      setCustomFieldKeys(customFieldsKeysArr);
      form.setFieldValue("customFields", customFields as string[]);
    }, [customFieldsMemoized, initialContactFormData, setCustomFieldKeys]);

    return (
      <form
        className={styles.appointFormMobile}
        onSubmit={(e) => {
          e.preventDefault();
          e.stopPropagation();
          form.handleSubmit();
        }}
      >
        <div className={styles.formWrapper}>
          {/* first name */}
          <form.AppField name="firstName">
            {field => (
              <field.TextInputField
                placeholder={t("please-enter")}
                label={t("first-name")}
              />
            )}
          </form.AppField>
          {/* last name */}
          <form.AppField name="lastName">
            {field => (
              <field.TextInputField
                placeholder={t("please-enter")}
                label={t("last-name")}
              />
            )}
          </form.AppField>
          {/* email */}
          <form.AppField name="email">
            {field => (
              <field.TextInputField
                placeholder={t("please-enter")}
                label={t("email")}
              />
            )}
          </form.AppField>
          {/* gender select */}
          <form.AppField name="gender">
            {(field) => {
              return (
                <field.SelectInputField
                  placeholder={t("please-select")}
                  label={t("gender")}
                  options={GENDER_OPTIONS}
                />
              );
            }}
          </form.AppField>
          <form.AppField name="phone">
            {field => <field.PhoneInputField label={t("phone")} />}
          </form.AppField>
          {/* custom fields */}
          {!!customFieldsTitle?.length && (
            <div className={styles.customFieldsContainer}>
              <form.Field
                name="customFields"
                mode="array"
                children={field =>
                  field?.state?.value?.map((_, index) => {
                    return (
                      <form.AppField
                        key={`customFields[${index}]`}
                        name={`customFields[${index}]`}
                      >
                        {field => (
                          <field.TextInputField
                            placeholder={t("please-enter")}
                            label={customFieldsTitle[index]}
                          />
                        )}
                      </form.AppField>
                    );
                  })}
              />
            </div>
          )}
        </div>
      </form>
    );
  },
});
